import { useSnackbarStore } from '@src/pinia/snackbar'
import { ISnackbar } from '@src/types/snackbar.types'
import { storeToRefs } from 'pinia'

export default function useSnackbar() {
  const store = useSnackbarStore()

  const { isSnackbarVisible, snackbar } = storeToRefs(store)
  function showSnackbar(sb: string | ISnackbar) {
    store.show(sb)
  }

  // Runs the current snackbar's trailing action. It dismisses the snackbar itself, so the
  // queue does not wait out the timeout.
  function runAction() {
    snackbar.value?.action?.handler()
    store.hideLatestSnackbar()
  }

  return {
    isSnackbarVisible,
    snackbar,
    showSnackbar,
    runAction,
    hideLatestSnackbar: store.hideLatestSnackbar
  }
}
